<template>
  <div class="block">
    <h2>
      {{ position }}
    </h2>
    <p>{{ copy }}</p>
    <p class="op1">
      <a :href="url" target="_blank">
        Join us →
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Block",
  props: {
    position: String,
    copy: String,
    url: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.block {
  width: 25%;
  padding-right: 3vw;
  color: inherit;
  min-height: 17vw;
  position: relative;
  h2 {
    @include headline-small;
  }
  p {
    a {
      //color:#CB7CFF;
      position: absolute;
      bottom: 0;
    }
  }
  &.disabled {
    opacity: 0.1;
    pointer-events: none;
    a {
      text-decoration: line-through;
    }
  }
}
@media (max-width: $tablet) {
  .block {
    width: 50%;
    margin-bottom: 50px;
    min-height: 180px;
  }
}
@media (max-width: $mobile) {
  .block {
    width: 100%;
    padding-right: 0;
    min-height: none;
    p a {
      position: relative;
    }
  }
}
</style>
